import request from '@/utils/request'

// 获取coin price
export function fetchCoinPrice(data) {
  return request({
    // usdt_fiat_currency_rate_list
    url: 'gyb_api/wallet/getCoinPrice',
    method: 'post',
    data
  })
}

// 获取usdt兑换法币汇率列表
export function fetchUsdtFiatCurrencyRateList() {
  return request({
    url: 'gyb_api/wallet/usdt_fiat_currency_rate_list',
    method: 'post'
  })
}

